import { apiFetch } from '../utils/apiClient';
import { CONTRACTS_URL, DEFAULT_PAGE_LIMIT } from '../constants/apiEndpoints';

// Fetch contracts by data provider (real API)
export async function fetchContractsByDataProvider(dataProviderId, limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') {
    const url = CONTRACTS_URL(dataProviderId, limit, offset, search);
    const response = await apiFetch(url, { method: 'GET' });
    return {
        contracts: response.contracts || [],
        count: response.count || 0,
        total: response.total || response.count || 0,
        hasMore: (response.contracts?.length || 0) === limit,
        dataProviderId: dataProviderId
    };
}